import type { IconName } from "../../../../../../../components/Icon/Icon.tsx";
import type {
  AlignmentAnchor,
  AlignmentScope,
} from "../../../Designer/types.ts";

export const LAYER_ALIGNMENT_ANCHOR_BUTTONS: Record<
  AlignmentAnchor,
  {
    iconName: IconName;
    tooltip: string;
  }
> = {
  left: {
    iconName: "AlignStartVertical",
    tooltip: "Horizontal align layers to the left of the canvas",
  },
  centerX: {
    iconName: "AlignCenterVertical",
    tooltip: "Horizontal align layers to the center of the canvas",
  },
  right: {
    iconName: "AlignEndVertical",
    tooltip: "Horizontal align layers to the right of the canvas",
  },
  top: {
    iconName: "AlignStartHorizontal",
    tooltip: "Vertical align layers to the top of the canvas",
  },
  centerY: {
    iconName: "AlignCenterHorizontal",
    tooltip: "Vertical align layers to the center of the canvas",
  },
  bottom: {
    iconName: "AlignEndHorizontal",
    tooltip: "Vertical align layers to the bottom of the canvas",
  },
};

export const LAYER_ALIGNMENT_SCOPE_BUTTONS: Record<
  AlignmentScope,
  {
    iconName: IconName;
    label: string;
  }
> = {
  canvas: {
    iconName: "LayoutDashboard",
    label: "Canvas",
  },
  selection: {
    iconName: "Group",
    label: "Selection",
  },
};
